import { LOSE_LIFE_TIMER } from "~/src/consts/config";
import { EVENT_GAME_OVER, EVENT_GAME_UPDATESCORE, EVENT_PACMAN_LOSELIFE, sceneEvents } from "~/src/events/GameEvents";
import Game from "~/src/scenes/Game";
import { red } from "../colors";
import Ghost from "../Ghost";
import Hero from "../Hero";

export function handleHeroGhostCollision(this: Game, h: Phaser.GameObjects.GameObject, g: Phaser.GameObjects.GameObject) {
  const hero = h as Hero;
  const ghost = g as Ghost;

  if (ghost.isNormal) {
    this.pauseGameWorld();
    sceneEvents.emit(EVENT_PACMAN_LOSELIFE);
    hero.die();

    this.time.delayedCall(
      LOSE_LIFE_TIMER,
      () => {
        this.lives = this.lives - 1;
        if (this.lives >= 0) {
          this.scene.restart({ init: false, level: this._level });
        } else {
          sceneEvents.emit(EVENT_GAME_OVER);
        }
      }
    );
  } else if (hero.isPowered) {
    if (!ghost.isRespawning) {

      ghost.handleEaten();

      const scoreText = this.add.text(
        ghost.x,
        ghost.y,
        `${this.pointsPerGhost}`,
        {
          color: red.rgba,
          fontSize: '16px',
          fontFamily: 'Emulogic',
          align: 'center',
        });

      sceneEvents.emit(EVENT_GAME_UPDATESCORE, this.pointsPerGhost);
      this.pointsPerGhost *= 2;

      this.time.delayedCall(500, () => {
        scoreText.destroy(true);
      });
    }
  }
}